// extracted by mini-css-extract-plugin
export default {"link":"QuestSearchResult_link__dDrtP","buttonLink":"QuestSearchResult_buttonLink__ZJ-7p","recommendations":"QuestSearchResult_recommendations__dEMJe"};